import { Cambio_profesional } from './../../../models/cambio_profesional.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
//migracion import { MatDatepickerInputEvent } from '@angular/material';



@Component({
    selector: "page-cambio_profesional",
    templateUrl: "./cambio_profesional.component.html", 
    providers: [FormService]
})

export class Cambio_profesionalComponent {
    
    public rows = [];
      public actualRow;
      public cambioDestino: Cambio_profesional;
      public form;
      
      matcher = new FormService();
      

    constructor( public _formService: FormService){

        this.form = new FormGroup({
            cambio_profesional: new FormControl(''),
        })

        if(!JSON.parse(localStorage.getItem("cambio_profesional"))){
            localStorage.setItem("cambio_profesional", JSON.stringify(this.rows));
        }else{
            
            this.rows = JSON.parse(localStorage.getItem("cambio_profesional"));

            this.form.controls['cambio_profesional'].setValue(this.rows[0]?this.rows[0].cambio_profesional:'')
            
            
        }

        
        

    }


    add_cambio_profesional(){


            
        localStorage.setItem("cambio_profesional",JSON.stringify([]));
        this.actualRow = localStorage.getItem("cambio_profesional");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            cambio_profesional: this.form.value.cambio_profesional,
        })

        localStorage.setItem("cambio_profesional", JSON.stringify(this.rows));
        //this.form.reset();

        //this.cip = JSON.parse(localStorage.getItem("cip"));

    }
    delete_cambio_profesional(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("cambio_profesional", JSON.stringify(this.rows));
            }
        }
    }
}